import axios, { AxiosRequestConfig } from 'axios';
import { CompanySafelist } from '../../types/company/CompanySafelist';
import { DataResponse, PagedResponse } from '../../types/api';

const URL = '/v2/company-safelist';

class CompanySafelistService {
  static get(
    id: number,
    config?: AxiosRequestConfig
  ): Promise<DataResponse<CompanySafelist>> {
    return axios.get(`${URL}/${id}`, config);
  }

  static getByFilter(
    config?: AxiosRequestConfig
  ): Promise<PagedResponse<CompanySafelist>> {
    return axios.get(URL, config);
  }

  static patch(
    id: number,
    data: CompanySafelist,
    config?: AxiosRequestConfig
  ): Promise<DataResponse<CompanySafelist>> {
    return axios.patch(`${URL}/${id}`, data, config);
  }

  static create(
    data: CompanySafelist,
    config?: AxiosRequestConfig
  ): Promise<DataResponse<CompanySafelist>> {
    return axios.post(URL, data, config);
  }

  static delete(id: number, config?: AxiosRequestConfig) {
    return axios.delete(`${URL}/${id}`, config);
  }
}

export { CompanySafelistService };
